/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './logo-grid';
import './logo-grid-item';
import './logo-grid-link';
import '../card/card-heading';
import '../content-block/content-block-heading';
